import { intl, mathService } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';

export const getNetSuiteAmountText = (
    amount: number,
    exchangeRate: number | null,
    requestCurrency: string,
    displayCurrency?: string
) => {
    if (!exchangeRate) {
        return '';
    }

    const amountText = intl.formatCurrency(
        mathService.multiply(amount, exchangeRate),
        displayCurrency || requestCurrency,
        2,
        false
    );

    if (exchangeRate !== 1 && displayCurrency && displayCurrency !== requestCurrency) {
        const amountRequestCurrency = intl.formatCurrency(amount, requestCurrency, 2);

        return `${amountText} (${amountRequestCurrency})`;
    }

    return amountText;
};

export const isMatchingLineColumnShown = (
    request: selectors.types.NetSuiteExpandedRequest,
    readonly: boolean | undefined
) => {
    return (
        !readonly &&
        (request.integrationCode === domain.IntegrationCode.NetSuiteBill ||
            (request.integrationCode === domain.IntegrationCode.NetSuitePO &&
                request.statusV2 === domain.RequestStatusV2.Approved &&
                Boolean(request.details.internalId)))
    );
};

export const isFieldVisible = (documentFieldState?: domain.DocumentFieldState) =>
    documentFieldState !== domain.DocumentFieldState.Hidden;
